import { styles } from '#pplx_generated/pplx/frontend/aether/primitives/ShimmerPrimitive/ShimmerPrimitive.module.css.js';
export const shimmerAnimationNames = [
    styles.shine,
    styles.shimmer,
    styles['shimmer-text-sweep'],
].filter((name) => name !== undefined);
//# sourceMappingURL=animationNames.js.map